// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';
import { HTMLColors } from '@Constants/colors';

interface IsSeenProps {
    value?: number;
    onChange?: (value: boolean) => void;
    readOnly?: boolean;
    onClick?: () => void;
    isIoc?: boolean;
}

export const IsSeen = ({ value, onChange, onClick, readOnly = false, isIoc }: IsSeenProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.EyeIcon />}
            value={!!value}
            onClick={
                (onClick || onChange) &&
                ((): void => {
                    onClick?.();
                    onChange?.(!value);
                })
            }
            readOnly={readOnly}
            onTrue={{
                color: isIoc ? HTMLColors.RED : HTMLColors.BLUE,
            }}
            label={i('observable.seen', { number: value + '' })}
        />
    );
};
